import { FC } from 'react';

type Props = {
	className?: string;
};

const GlobeIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2 9.32548C2.31438 5.89835 4.75862 3.09151 7.98992 2.25481C7.9404 2.35713 7.8907 2.46239 7.84102 2.57056C7.08859 4.20864 6.32965 6.5321 6.2664 9.32541L2 9.32548ZM2.00004 10.828C2.3288 14.4098 4.98406 17.314 8.43276 17.9995C8.24393 17.6602 8.04237 17.2694 7.84102 16.8311C7.15717 15.3423 6.46794 13.2874 6.3005 10.828H2.00004ZM7.80026 10.828C7.96357 12.9492 8.56292 14.7358 9.16749 16.0518C9.46262 16.6944 9.75724 17.2208 9.99895 17.6143C10.2407 17.2208 10.5353 16.6944 10.8305 16.0518C11.435 14.7358 12.0343 12.9492 12.1977 10.828H7.80026ZM13.6974 10.828C13.53 13.2874 12.8408 15.3423 12.1569 16.8311C11.9555 17.2696 11.7539 17.6605 11.5649 17.9999C15.0146 17.3152 17.6708 14.4106 17.9997 10.828H13.6974ZM17.9998 9.32548H13.7315C13.6682 6.5321 12.9093 4.20864 12.1569 2.57056C12.1071 2.46221 12.0573 2.35676 12.0078 2.25428C15.2401 3.09031 17.6853 5.89762 17.9998 9.32548ZM12.2362 9.32548L7.76169 9.32541C7.82451 6.87357 8.49277 4.81865 9.16749 3.34982C9.4121 2.81723 9.65633 2.36444 9.87043 2.00103C9.91352 2.00034 9.95661 2 9.99984 2C10.0425 2 10.085 2.00033 10.1275 2.001C10.3416 2.36441 10.5858 2.81721 10.8305 3.34982C11.5052 4.81865 12.1734 6.87357 12.2362 9.32548Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default GlobeIconSolid;
